// Version : 0.0.1
// Author : VIGNESH
const AssignUserRightsTypes = {
	/** *********************  START ADD USER ASSIGN CONTROL RIGHTS PAGE DETAILS  ******************** */
	CREATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_START: 'create_user_assign_control_rights_page_start',
	CREATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_SUCCESS:
		'create_user_assign_control_rights_page_success',
	CREATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_FAILURE:
		'create_user_assign_control_rights_page_failure',
	CREATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_RESPONSE_RESET:
		'create_user_assign_control_rights_page_response_reset',
	CREATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_RESPONSE_CHANGED:
		'create_user_assign_control_rights_page_response_changed',

	/** ********************* ADD USER ASSIGN CONTROL RIGHTS PAGE DETAILS END ******************** */

	/** *********************  START UPDATE USER ASSIGN CONTROL RIGHTS PAGE DETAILS  ******************** */

	UPDATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_START: 'update_user_assign_control_rights_page_start',
	UPDATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_SUCCESS:
		'update_user_assign_control_rights_page_success',
	UPDATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_FAILURE:
		'update_user_assign_control_rights_page_failure',
	UPDATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_RESPONSE_RESET:
		'update_user_assign_control_rights_page_response_reset',
	UPDATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_RESPONSE_CHANGED:
		'update_user_assign_control_rights_page_response_changed',

	/** ********************* UPDATE USER ASSIGN CONTROL RIGHTS PAGE DETAILS END ******************** */

	/** *********************  START SAVE USER ASSIGN CONTROL RIGHTS ALL PAGE  ******************** */

	SAVE_USER_ASSIGN_CONTROL_ALL_PAGE_START: 'save_user_assign_control_all_page_start',
	SAVE_USER_ASSIGN_CONTROL_ALL_PAGE_SUCCESS: 'save_user_assign_control_all_page_success',
	SAVE_USER_ASSIGN_CONTROL_ALL_PAGE_FAILURE: 'save_user_assign_control_all_page_failure',
	SAVE_USER_ASSIGN_CONTROL_ALL_PAGE_RESPONSE_RESET:
		'save_user_assign_control_all_page_response_reset',
	SAVE_USER_ASSIGN_CONTROL_ALL_PAGE_RESPONSE_CHANGED:
		'save_user_assign_control_all_page_response_changed',

	/** ********************* SAVE USER ASSIGN CONTROL RIGHTS ALL PAGE END ******************** */

	/** *********************  START FETCH USER ASSIGN CONTROL RIGHTS PAGE DETAILS  ******************** */

	FETCH_LIST_USER_CONTROL_DETAILS_START: 'fetch_list_user_control_details_start',
	FETCH_LIST_USER_CONTROL_DETAILS_SUCCESS: 'fetch_list_user_control_details_success',
	FETCH_LIST_USER_CONTROL_DETAILS_FAILURE: 'fetch_list_user_control_details_failure',
	FETCH_LIST_USER_CONTROL_DETAILS_RESPONSE_RESET:
		'fetch_list_user_control_details_response_reset',
	FETCH_LIST_USER_CONTROL_DETAILS_ARR_RESET: 'fetch_list_user_control_details_arr_reset',
	FETCH_LIST_USER_CONTROL_DETAILS_RESPONSE_CHANGED:
		'fetch_list_user_control_details_response_changed',
	FETCH_LIST_USER_CONTROL_DETAILS_ARR_CHANGED: 'fetch_list_user_control_details_arr_changed',

	/** ********************* FETCH USER ASSIGN CONTROL RIGHTS PAGE DETAILS END ******************** */
};
export default AssignUserRightsTypes;
